import * as User from "./User";
import * as Blog from "./Blog";
import * as Category from "./Category";
import * as Mindfulness from "./Mindfulness";
import * as File from "./File";
import * as Order from "./Order";
import * as Location from "./Location";
import * as PasswordResetCode from "./PasswordResetCode";
import * as PremiumContent from "./PremiumContent";
import * as ReferralCode from "./ReferralCode";
import * as Snaps from "./Snaps";
import * as Stories from "./Stories";
import * as Subscription from "./Subscription";
import * as Tag from "./Tag";
import * as Product from "./Product";
import * as Language from "./Language";

export default {
  ...User,
  ...Blog,
  ...Category,
  ...Mindfulness,
  ...File,
  ...Order,
  ...Location,
  ...PasswordResetCode,
  ...PremiumContent,
  ...Product,
  ...ReferralCode,
  ...Tag,
  ...Stories,
  ...Subscription,
  ...Snaps,
  ...Language,
};